export default defineNuxtRouteMiddleware(async (to) => {
    if (to.path === "/maintenance") {
        // If the user is already on the maintenance page, do nothing
        return;
    }

    const client = useSanctumClient();

    const pages = {
        registration: ["/register", "/register-merge", "/register-tablet"],
    };

    let data: string[] = [];
    try {
        data = await client("/api/maintenance");
    } catch (error) {
        console.error("Failed to fetch maintenance status:", error);
        return;
    }

    if (data.includes("registration")) {
        if (pages.registration.includes(to.path)) {
            return navigateTo("/maintenance?message=registration");
        }
    }
});
